import { useGlobalStateStore } from "../../stores/store";
import { loadNextOddsPage } from "../interactors/odds";
import moment from 'moment'

const Pagination = () => {
  const store = useGlobalStateStore();
  const activeTab = store.getActiveTab(); // ✅ Read from global state

  const onShowMoreClicked = () => {
    const exp = moment(localStorage.getItem("exp"));
    const now = moment();
    if (exp.isBefore(now)) {
      window.location.href = "/auth";
    }

    loadNextOddsPage(store, {
      tab: activeTab,
      pagination: true,
      onSuccess: (itemsLoaded) => {
        if (itemsLoaded === 0) {
          store.setCanLoadMore(false);
        }
      },
    });
  };

  return (
    <nav className="pagination">
      <button
        type="button"
        className="show-more-btn"
        onClick={onShowMoreClicked}
      >
        Show more
      </button>
    </nav>
  );
};

export default Pagination;
